"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ListingContainer = _interopRequireDefault(require("./ListingContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ListingContainer.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/index.js
// module id = 252
// module chunks = 0